<app-card-template [config]="cardConfig">
  <div class="connected-users-header" cardHeaderActions>
    <div class="header-content">
      <span class="refresh-timer">(refresco en {{ timerSeconds }} segs)</span>
      <button
        mat-icon-button
        color="accent"
        class="refresh-button"
        [disabled]="isLoading$ | async"
        matTooltip="Refrescar usuarios conectados"
        (click)="onRefresh()"
      >
        <mat-icon aria-label="Refrescar usuarios conectados">sync</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="usersData$ | async as usersData; else loadingOrError" class="users-stats">
    <div class="stat-section">
      <div class="stat-label">Total</div>
      <div class="stat-value total">{{ usersData.total }}</div>
    </div>
    <div class="stat-section">
      <div class="stat-label">Con raqueta</div>
      <div
        class="stat-value clients"
        [ngClass]="getClientsStatClass(usersData.clients)"
        (click)="onClientsStatClick(usersData.clients)"
      >
        {{ usersData.clients }}
      </div>
    </div>
    <div class="stat-section">
      <div class="stat-label">Invitados</div>
      <div class="stat-value invited">{{ usersData.invited }}</div>
    </div>
  </div>

  <ng-template #loadingOrError>
    <div *ngIf="isLoading$ | async" class="loading">
      <p>Cargando usuarios...</p>
    </div>
    <div *ngIf="error$ | async as error" class="error">
      <p>{{ error }}</p>
    </div>
    <div *ngIf="!(isLoading$ | async) && !(error$ | async)" class="no-data">
      <p>No hay datos disponibles</p>
    </div>
  </ng-template>
</app-card-template>
